import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { GuestGuard } from 'src/auth/guard';
import AuthClassicLayout from 'src/layouts/auth/classic';
import { SplashScreen } from 'src/components/loading-screen';
import CompactLayout from 'src/layouts/compact';

const JwtLoginPage = lazy(() => import('src/pages/auth/login'));
const RequestPage = lazy(() => import('src/pages/auth/recovery/Request'));
const UpdatePage = lazy(() => import('src/pages/auth/recovery/Update'));

export const authRoutes = [
  {
    path: 'auth',
    element: (
      <GuestGuard>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </GuestGuard>
    ),
    children: [
      {
        path: 'login',
        element: (
          <AuthClassicLayout>
            <JwtLoginPage />
          </AuthClassicLayout>
        ),
      },
      {
        path: 'recovery',
        element: (
          <AuthClassicLayout>
            <RequestPage />
          </AuthClassicLayout>
        ),
      },
      {
        path: '',
        element: <Navigate to="/auth/login" replace />,
      },
    ],
  },
  {
    path: 'password-recover/:token',
    element: (
      <CompactLayout disabled>
        <Suspense fallback={<SplashScreen />}>
          <UpdatePage />
        </Suspense>
      </CompactLayout>
    ),
  },
];
